import { createAction } from '@ngrx/store';

export const OpenSidenav = createAction(
  '[Data Customization: Tag Management]: Sidenav Opened'
);

export const CloseSidenav = createAction(
  '[Data Customization: Tag Management]: Sidenav Closed'
);
